/* eslint-disable no-magic-numbers */

import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { CLIENT_POLICY_API_PATH } from './constants';
import {
  GET_CLIENT_POLICY_DEFAULTS_RESPONSE,
  GET_CLIENT_POLICY_RESPONSE,
} from './fixtures';

export const clientPoliciesHandlers = [
  http.get(`*${CLIENT_POLICY_API_PATH}/defaults`, () =>
    HttpResponse.json(GET_CLIENT_POLICY_DEFAULTS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${CLIENT_POLICY_API_PATH}`, () =>
    HttpResponse.json(GET_CLIENT_POLICY_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(
    `*${CLIENT_POLICY_API_PATH}/:clientId?country_code=:countryCode`,
    ({ request }) => {
      const url = new URL(request.url);
      const countryCode = url.searchParams.get('country_code');
      const clientPolicy =
        GET_CLIENT_POLICY_RESPONSE.find(
          (item) => item.country.code === countryCode,
          // eslint-disable-next-line no-magic-numbers
        ) || GET_CLIENT_POLICY_RESPONSE[0];

      return HttpResponse.json(
        countryCode ? [clientPolicy] : GET_CLIENT_POLICY_RESPONSE,
        {
          status: HTTPStatusCodes.OK,
        },
      );
    },
  ),
  http.post(`*${CLIENT_POLICY_API_PATH}/:clientId`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.put(`*${CLIENT_POLICY_API_PATH}/:clientId`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.delete(`*${CLIENT_POLICY_API_PATH}/:clientId`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
];
